import { FC } from 'react'
import { IInvestmentBase } from '@/types'
import { PortfolioCard } from '@components-v2/molecules/PortfolioCard'
import { ProfileCardListGrid } from '@components-v2/organisms/ProfileCardListGrid'

type Props = {
  investments: IInvestmentBase[]
}

export const ProfilePortfolio: FC<Props> = ({ investments }) => {
  return (
    <ProfileCardListGrid>
      {investments.map((inv) => {
        return <PortfolioCard key={inv.id} investment={inv} />
      })}
    </ProfileCardListGrid>
  )
}
